import * as types from './actionTypes';
import { getProducts } from './searchActions';
import { productsSearchApiErrorMsg } from '../../Constants/ErrorMessages';
import { openErrorSnackBar } from './snackBarActions';
import { logAndReturnErrorMsg } from '../../Utils/ErrorLog';
import { isNumeric } from '../../Utils/GlobalUtils';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}
//gets data from the requested url and returns a promise
export function getProductsTabSearchOptions(value) {
	return function (dispatch) {
		return getProducts(value)
			.then((response) => {
				// when there is no product returned. add the input value to the list (to add a refresh button as select option).
				const { data } = response;
				if (isNumeric(value) && data.length === 0) {
					data.push({
						inputValue: value,
						shouldRefresh: true,
					});
				}
				dispatch(dispatchActionData(types.SET_PRODUCTS_TAB_SEARCHDATA, data));
			})
			.catch((error) => {
				dispatch(openErrorSnackBar(logAndReturnErrorMsg(error, productsSearchApiErrorMsg)));
			})
			.finally(() => {});
	};
}
